<template>
  <div>
    <template v-if="!loading && !getFilesListStatus">
      <scan-card
        v-for="file in files"
        :key="file.fileType"
        :item="file"
        :cols="cols"
        :disabled="calcDisabledFile(file)"
        :upload-to-serv-now="loadingFileToServer.fileType === file.fileType && loadingFileToServer.value"
        :downloading-file="downloadingFileToServer.fileType === file.fileType && downloadingFileToServer.value"
        @replace-file="replaceFile($event)"
        @delete-file="deleteFile($event)"
        @upload-file="uploadFile($event)"
        @get-file="downloadFile($event)"
        identifier="fileType"
      >
      </scan-card>
    </template>
    <div v-else class="d-flex flex-row align-center justify-center">
      <v-progress-circular indeterminate size="45" color="primary"/>
    </div>
  </div>
</template>

<script>
import ScanCard from "@/components/cards/scanCard";
import {setFileFunctions} from "@/mixins/fileFucntions";
import {mapGetters, mapActions} from "vuex";
import FilesController from "@/controllers/FilesController";
import RegionController from "@/controllers/OKCP/RegionController";

export default {
  name: "FileContainer",
  mixins: [setFileFunctions],
  components: {ScanCard},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    filesConfig: {
      type: Array,
      required: true,
      /*
      * item of array
      * {
      * name: '',
      * types: ['application/pdf'],
      * fileType: ''
      * }
      * */
      default: () => ([])
    },
    numStage: {
      type: Number,
      default: 1
    },
    currentStage: {
      type: Number,
      default: 0
    },
    cols: {
      type: Number,
      default: 4
    },
    regionID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      files: [],
      regionsWithFiles: [],
    }
  },
  computed: {
    ...mapGetters('keycloak', {isAdmin: 'isAdmin', getFakeUser: 'getFakeUser'}),
    ...mapGetters('checkFilled', {
      getFilesListStatus: 'getFilesListStatus',
      getFilesList: 'getFilesList',
      getBlockInfo: 'getBlockInfo',
    }),
    uniqueFilesForRegions() { // сканы по региону
      if (this.regionID !== 0 && this.regionsWithFiles.filter(el => el.id === this.regionID)[0] === undefined) {
        return null // ещё нет файла по региону
      } else { // файл по региону есть - возвращаем объект
        return this.regionsWithFiles.filter(el => el.id === this.regionID)[0]
      }
    },
  },
  watch: {
    getFilesListStatus() {
      this.$nextTick(() => this.initFiles())
    }
  },
  created() {
    if (this.getFilesListStatus === false)
      this.initFiles()
  },
  methods: {
    ...mapActions('checkFilled', {updateFiles: 'updateFiles'}),
    ...mapActions('checkFilled', {reloadFiles: 'reloadFiles'}),
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    calcDisabledFile(file) {
      if (this.isAdmin) return false;
      return file?.disabled ?? this.disabled
    },
    async initFiles() {
      await this.reloadFiles();
      this.files = [];
      await RegionController.getRegionsWithScanFilesData().then(data => { // TODO переместить это в vuex
        this.regionsWithFiles = data.filter(el => el.scan !== null)
      })
      this.loading = true;
      this.files = this.filesConfig.map(el => {
        let file;

        if (this.uniqueFilesForRegions === undefined) { // базовый вариант для старых файлов
          file = this.getFilesList ? this.getFilesList.find(data =>
              (el.fileType === data.fileType)
              && (this.userId === data.userId || this.getFakeUser.id === data.userId))
            : null;
        } else if (this.uniqueFilesForRegions === null) { // вариант если ещё НЕ загружен файл по этому региону (через description)
          file = null
        } else { // вариант если уже загружен файл по этому региону (через description)
          file = this.uniqueFilesForRegions
        }
        if (file)
          return {
            ...el, ...file,
            disabled: !!((this.getBlockInfo?.find(el => el.stageId === this.numStage)?.block && this.numStage !== this.currentStage || this.disabled) && file.id)
          }
        else
          return {
            ...el,
            disabled: !!((this.getBlockInfo?.find(el => el.stageId === this.numStage)?.block || this.disabled) && file?.id)
          }
      });
      this.loading = false;
    },
    async uploadFile(event) {
      this.loadingFileToServer.value = true;
      this.loadingFileToServer.fileType = event.fileType;
      let fd = new FormData();
      fd.append('file', event.file);
      try {
        await FilesController.saveFile(event.fileType, event.file, String(this.regionID)).then(data => {
          const file = this.files.find(el => event.fileType === el.fileType);
          for (const [key, value] of Object.entries(data)) {
            file[key] = value
          }
          this.updateFiles(data);
          if (this.numStage === 3) {
            this.$emit('getAll', 1);
          }
        }).finally(() => this.loadingFileToServer.value = false)
      } catch (e) {
        this.loadingFileToServer.value = false;
        console.error(e)
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Ошибка загрузки',
          timeout: 3000
        })
      }
    },
    async deleteFile(event) {
      console.log(event);
      try {
        const response = await FilesController.deleteFile(event.id)
        if (response) {
          const fileIndex = this.files.findIndex(el => event.fileType === el.fileType);
          this.files.splice(fileIndex, 1, {
            name: this.files[fileIndex].name,
            fileType: event.fileType,
            id: null,
            types: this.files[fileIndex].types
          })
        }
      } catch (e) {
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Ошибка удаления',
          timeout: 3000
        });
        console.log("e delete", e)
      }
    },
    replaceFile(event) {
      this.deleteFile(event).then(() => this.uploadFile(event))
    },
  },
}
</script>

<style scoped>

</style>